<template>
  <div class="page-content" style="padding-top: 4rem">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="card" id="orderList">
            <div class="card-header border-0">
              <div class="d-flex align-items-center" style="text-align: left">
                <h5 class="card-title mb-0 flex-grow-1">All Faqs</h5>
                <div class="flex-shrink-0">
                  <button
                    @click="this.$router.push('/add_faq')"
                    type="button"
                    class="btn btn-success add-btn"
                  >
                    <i class="ri-add-line align-bottom me-1"></i>
                    Add Faq
                  </button>
                </div>
              </div>
            </div>
            <div
              class="card-body border border-dashed border-end-0 border-start-0"
            >
              <form>
                <div class="row g-3">
                  <div class="col-xxl-5 col-sm-6">
                    <div class="search-box">
                      <input
                        type="text"
                        class="form-control search"
                        placeholder="Enter Question"
                        fdprocessedid="vrqiwe"
                        v-model="search_key"
                        v-on:change="getFaqList(1)"
                      />
                      <i class="ri-search-line search-icon"></i>
                    </div>
                  </div>
                </div>
                <!--end row-->
              </form>
            </div>
            <div class="card-body pt-0">
              <div class="mt-5">
                <div class="table-responsive table-card mb-1">
                  <div class="noresult" v-if="noData">
                    <rb-loading-table />
                  </div>
                  <div v-else>
                    <rb-data-table
                      :ldata="this.ldata"
                      :headers="headers"
                      :tableData="formattedFaq"
                      :editBtn="true"
                      :serverErr="this.server_err"
                      @edit="editFaq"
                      @delete="delFaq1"
                    />
                  </div>
                </div>
                <div class="d-flex justify-content-end" v-if="!noData">
                  <div
                    class="pagination-wrap hstack gap-2"
                    style="display: flex"
                  >
                    <a
                      class="page-item pagination-prev px-4"
                      v-if="pageNo > 1"
                      @click="getFaqList(pageNo - 1)"
                      href="javascript:void(0)"
                    >
                      <i class="ri-arrow-left-line"></i>
                    </a>
                    <ul
                      class="pagination listjs-pagination mb-0"
                      v-if="this.faqs.length > 0"
                    >
                      <li class="active">
                        <a class="page" href="javascript:void(0)">{{
                          pageNo
                        }}</a>
                      </li>
                      <li>
                        <a
                          v-if="this.faqs.length >= 10"
                          class="page"
                          href="javascript:void(0)"
                          @click="getFaqList(pageNo + 1)"
                          >{{ pageNo + 1 }}</a
                        >
                      </li>
                    </ul>
                    <a
                      v-if="this.faqs.length >= 10"
                      class="page-item pagination-next px-4"
                      href="javascript:void(0)"
                      @click="getFaqList(pageNo + 1)"
                    >
                      <i class="ri-arrow-right-line"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useAuthStore } from "@/store/auth";
import { getFaqs, delFaq } from "@/apis/faqapis";

export default {
  name: "AppFaqList",

  data() {
    return {
      page_count: 10,
      pageNo: 1,
      noData: true,
      faqs: [],
      search_key: "",
      headers: [
        {
          name: "Questions",
          dataSort: "id",
        },
        {
          name: "Type",
          dataSort: "customer_name",
        },
        {
          name: "Category",
          dataSort: "product_name",
        },
        {
          name: "Answer",
          dataSort: "date",
        },
        {
          name: "Actions",
          dataSort: "date",
          auth: false,
        },
      ],
    };
  },
  methods: {
    async getFaqList(pno) {
      if (pno != 0) {
        this.pageNo = pno;
      }
      this.noData = true;
      const response = await getFaqs(
        this.pageNo,
        this.page_count,
        this.search_key
      );
      if (response.status) {
        this.faqs = response.data;
        this.noData = false;
      } else {
        this.faqs = [];
        this.noData = true;
      }
    },
    async delFaq1(city) {
      const isConfirmed = confirm("Are you sure you want to delete this item?");
      if (isConfirmed) {
        const response = await delFaq(city.faq_id);
        if (response.status) {
          this.msgType = "success";
          this.msgTxt = response.message;
          this.getFaqList(0);
        } else {
          this.msgType = "danger";
          this.msgTxt = response.message;
        }
      }
    },
    editFaq(city) {
      localStorage.setItem("faq_edit_data", JSON.stringify(city));
      this.$router.push("/add_faq");
    },
  },
  mounted() {
    this.getFaqList(1);
  },
  computed: {
    ...mapState(useAuthStore, ["ldata"]),

    formattedFaq() {
      return this.faqs.map((faq) => ({
        id: faq.faq_id,
        question: faq.faq_title || "N/A",
        type: faq.faq_cat1 || "N/A",
        category: faq.faq_cat || "N/A",
        answer: faq.faq_ans || "N/A",
      }));
    },
  },
};
</script>
